import { render, staticRenderFns } from "./PerfilSociodemograficoPagination.vue?vue&type=template&id=2f0025b1&"
import script from "./PerfilSociodemograficoPagination.vue?vue&type=script&lang=js&"
export * from "./PerfilSociodemograficoPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports